<div class="bmc-job-schedules">
  <p>{{'JOBS.SCHEDULES_DESCRIPTION' | translate}}</p>
  <div class="bmc-job-schedules__table">
    <table class="bz-table">
      <thead>
      <tr>
        <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns">
          <div class="bz-table__col-title"
                [ngClass]="{'bmc-job-schedules__table-title': !isDevelopment}"
               *ngIf="col.visible">
            <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let schedule of currentJob.schedules">
        <td class="bz-table__cell" *ngFor="let col of columns" [ngClass]="{'bmc-job-schedules__table-edit': !isDevelopment}">
          <div *ngIf="col.visible">

            <div *ngIf="isDevelopment">
              <div *ngIf="col.type === 'link' "><a (click)="col.action(schedule)">{{ schedule[col.key] }}</a></div>
              <div *ngIf="col.type === 'text' ">{{ schedule[col.key] }}</div>
              <div *ngIf="col.type === 'type' ">{{ 'JOBS.SCHEDULE_TYPE_' + (schedule[col.key] | uppercase) | translate }}</div>
              <div *ngIf="col.type === 'frequency' ">{{ schedule.frequency[col.key] }}</div>
              <div *ngIf="col.type === 'frequencyType'">{{ 'JOBS.SCHEDULE_TYPE_' + (schedule.frequency[col.key] | uppercase) | translate }}</div>
              <div *ngIf="col.type === 'date' ">{{ schedule[col.key] | showDateFormat: 1}}</div>
              <div *ngIf="col.type === 'boolean'">
                <bzg-checkbox [checked]="schedule[col.key]" [disabled]="col.readonly"></bzg-checkbox>
              </div>
            </div>
            
            <div *ngIf="!isDevelopment">
              <div *ngIf="col.type === 'link'"><a (click)="col.action(schedule)">{{ schedule[col.key] }}</a></div>
              <div *ngIf="col.type === 'text'">
                <input 
                  [(ngModel)]="schedule[col.key]" 
                  class="bmc-job-schedules__input" 
                  type="text"
                  [class.valid]="isValidScheduleName[getOrCreateScheduleId(schedule)] === true"
                  [class.invalid]="isValidScheduleName[getOrCreateScheduleId(schedule)] === false"
                  (input)="validateInputScheduleName($event, schedule)"
                  maxlength="26"
                />
              </div>
              <div *ngIf="col.type === 'type'">{{ 'JOBS.SCHEDULE_TYPE_' + (schedule[col.key] | uppercase) | translate }}</div>
              <div *ngIf="col.type === 'frequency'" class="bmc-job-schedules__table__frequency">
                <input 
                  [(ngModel)]="schedule.frequency[col.key]" 
                  class="bmc-job-schedules__input"
                  type="text" (keypress)="numberOnly($event)"
                  pattern="[0-9]*" maxlength="9"
                >
              </div>
              <div *ngIf="col.type === 'frequencyType'">
                <bzg-select 
                  [(ngModel)]="schedule.frequency[col.key]"
                  [value]="schedule.frequency[col.key]">
                  <bzg-option *ngFor="let scheduleType of scheduleTypes" [value]="scheduleType.value">
                    {{ 'JOBS.SCHEDULE_TYPE_' + (scheduleType.name | uppercase) | translate }} 
                  </bzg-option>
                </bzg-select>
              </div>
              <div *ngIf="col.type === 'date'">
                <bz-date-time-picker 
                  [currentDate]="schedule[col.key]" 
                  [dateMax]="dateMax"
                  (valueChange)="onDateChange($event, schedule, col)">
                </bz-date-time-picker>
              </div>
              <div *ngIf="col.type === 'boolean'" class="bmc-job-schedules__checkbox">
                <bzg-checkbox 
                  [(ngModel)]="schedule[col.key]"
                  [checked]="schedule[col.key]">
                </bzg-checkbox>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <bzg-message  *ngIf="showValidationMessage" [showCloseBtn]="false" [status]="'warning'">
    <span class="bz-space--inline-s "> {{validationMessage | translate}} </span>
  </bzg-message>
</div>

<!-- <div *ngIf="!allScheduleNamesValid && currentJob" class="bmc-job-schedules__buttons bz-flex bz-flex--end">
  <div class="bmc-job-schedules__validation-message">
      <bzg-icon [nameIcon]="'icon-warning'" [color]="'warning'" class="bz-space--inline-xs"></bzg-icon>
      {{'JOBS.STEPS_SCHEDULES_NAME_VALIDATION_MESSAGE' | translate}}
  </div>
</div> -->
